export enum FeatureFlags {
  ICD11 = 'ICD11',
  messaging = 'messaging',
  ehr = 'ehr',
  providerLevelBillingProfiles = 'providerLevelBillingProfiles',
  eraViewingPostingRevamp = 'eraViewingPostingRevamp',
  collaborativeEncounter = 'collaborativeEncounter',
  serviceCodeUsageReport = 'serviceCodeUsageReport',
  customSurveys = 'customSurveys',
  eraClaimNotes = 'eraClaimNotes',
  dejavoo = 'dejavoo',
  adHocReports = 'adHocReports',
  patientDocuments = 'patientDocuments',
  hostedSMS = 'hostedSMS',
  patientWidgetBar = 'patientWidgetBar',
  patientRelationships = 'patientRelationships',
  chat = 'chat',
  patientInsuranceAutoApply = 'patientInsuranceAutoApply',
  homePageV2 = 'homePageV2',
  reportSnapshots = 'reportSnapshots',
  serviceLineLevelBilling = 'serviceLineLevelBilling',
  ehrPatientRecallBoard = 'ehrPatientRecallBoard',
  customForms = 'customForms',
  deepgram = 'deepgram',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  collabPilot = 'collabPilot',
  collabPilotPlusMessaging = 'collabPilotPlusMessaging',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'CollabPilot',
    value: 'collabPilot',
  },
  {
    label: 'CollabPilotPlusMessaging',
    value: 'collabPilotPlusMessaging',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
